export default __webpack_public_path__ + "static/a_star-56c8ded712ebdf0d0eae5d5056fa3669.png";